import React,{Component} from "react";
import Slider from "react-slick";
import './c.css'
import {getInitials} from '../../../../Utility'
let contacts=[],number_of_items=3
var width = (window.innerWidth > 0) ? window.innerWidth : Screen.width;
class ContactV extends Component {
  componentWillReceiveProps(nextProps) {
    if(width<1200)
    number_of_items=1
    contacts = nextProps.transporter_data.contact_information
    if (!contacts) { contacts = [] }
    
    
  }
  
 
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: number_of_items,
      slidesToScroll: 1,
      className:"contactCard"
    };
    return (
      <div class="container contact_Details_Body">
     {
       (contacts && contacts.length>0) ?(
      <Slider {...settings}>
        {
          contacts.map((index,i)=>{
            return  <div className="contactCardBody" key={i}>
          <div className="row">
            <div className="upperSection">
  
              <div className="col-md-3 contact_image">
                {
                  (index.profile_image) ? (
                    <img src={index.profile_image} />
                  ) : (
                    <div className="avatar-circle">
                    <span class="initials">
                      {getInitials(index.name)}
                    </span>
                  </div>
                    )
                }
              </div>
              <div className="col-md-9 personal">
                  <span className="name"><b>{index.name} </b> </span><br></br>
                  <span className="designation"> {index.designation} </span>
                
              </div>
            </div>
            <div className="col-md-12 text-center" style={{paddingBottom: "10px"}}>
            <span className="designation"> {index.email} </span>
              {/* <p>
                {
                  (index.poc === "yes" || index.poc === "YES" || index.poc === "y" || index.poc === "Y" || index.poc === "true") ? (
                    <span className="poc_verify">  <i className="fa fa-phone"></i> {index.contact_number} </span>
  
                  ) : (
                      <span className="contactNumber"> {index.contact_number} </span>
                    )
                }
                <br />
                <span className="email"> {index.email} </span> <i className="fa fa-phone-alt"></i>
              </p> */}
            </div>
          </div>




            </div>
            
          })
        }
      </Slider>
      
      ):(
        <>
      <h4 className="data_header">Contact Information</h4>
      <span >Details not available</span>
      </>
      )
      }
      <br/>
     
      </div>

      
    );
  }
}
export default ContactV